import type { ReduxSelector } from 'store/store.types';
import { NOTIFICATIONS_SLICE_NAME } from '../slicesNames';
import { NotificationSeverity } from './notificationsConstants';
import { NotificationActionButton } from './notification.types';

/** Message displayed in alert */
export const message: ReduxSelector<string | null> = (state) =>
  state[NOTIFICATIONS_SLICE_NAME].message;

/** The variant of alert - success, info, warning or error */
export const severity: ReduxSelector<NotificationSeverity> = (state) =>
  state[NOTIFICATIONS_SLICE_NAME].severity;

/** True if the notification is shown currently */
export const isOpen: ReduxSelector<boolean> = (state) => state[NOTIFICATIONS_SLICE_NAME].isOpen;

/** The duration of the notification in milliseconds before it's auto closed */
export const duration: ReduxSelector<number | null> = (state) =>
  state[NOTIFICATIONS_SLICE_NAME].duration;

/** The key of the focusAnchor to return to after close */
export const returnFocusKey: ReduxSelector<string | null> = (state) =>
  state[NOTIFICATIONS_SLICE_NAME].returnFocusKey;

/** Optional action button to display in the notification */
export const actionButton: ReduxSelector<NotificationActionButton | null> = (state) =>
  state[NOTIFICATIONS_SLICE_NAME].actionButton;
